import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import Section from './Section.jsx';
import { formatTime } from '../lib/format.js';

export default function TideChart({ tides }) {
  if (!tides?.curve?.length) return null;

  const events = tides.events || [];

  return (
    <Section id="tide" title="Tides" eyebrow={tides.station}>
      <div className="mb-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
        {events.map((e, i) => (
          <div key={i} className="rounded-lg bg-cream-100 px-3 py-2">
            <div className="text-xs uppercase tracking-wide text-navy-500">
              {e.type === 'high' ? 'High' : 'Low'}
            </div>
            <div className="font-display text-base font-semibold text-navy-900">
              {formatTime(e.time)}
            </div>
            <div className="text-xs text-navy-600">{e.height.toFixed(1)} ft</div>
          </div>
        ))}
      </div>
      <div className="h-48 rounded-xl bg-cream-50 p-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={tides.curve} margin={{ top: 12, right: 12, left: 0, bottom: 0 }}>
            <XAxis
              dataKey="time"
              ticks={['06:00', '12:00', '18:00']}
              tickFormatter={(t) => (t === '12:00' ? 'Noon' : formatTime(t).replace(':00', ''))}
              stroke="#5d83ad"
              fontSize={11}
            />
            {/* Whole-foot gridlines with the unit on the axis; the precise
                heights live in the high/low cards above the chart. */}
            <YAxis
              stroke="#5d83ad"
              fontSize={11}
              domain={[(dataMin) => Math.min(0, Math.floor(dataMin)), (dataMax) => Math.ceil(dataMax)]}
              allowDecimals={false}
              tickFormatter={(v) => `${Math.round(v)} ft`}
            />
            <Tooltip
              contentStyle={{ backgroundColor: '#16263c', border: 'none', borderRadius: 6, color: '#fdfaf3', fontSize: 12 }}
              formatter={(v) => [`${v.toFixed(1)} ft`, 'Tide']}
              labelFormatter={(t) => formatTime(t)}
            />
            <Line
              type="monotone"
              dataKey="height"
              stroke="#16263c"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Section>
  );
}
